import React from "react";
import AQUAd from "./assets/AQUAd.svg";
import phk from "./assets/phk.jpg";
import tue from "./assets/tue.png";
import mwk from "./assets/mwk.png";

const outerBoxStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "32px 0 12px 0",
    width: "100%",
    background: "transparent",
};

const containerStyle: React.CSSProperties = {
    border: "1px solid #e3e3e3",
    borderRadius: 8,
    background: "#fff",
    boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
    padding: "16px 32px",
    maxWidth: 700,
    width: "100%",
    display: "flex",
    gap: 32,
    alignItems: "center",
    justifyContent: "center",
};

const copyrightStyle: React.CSSProperties = {
    marginTop: 16,
    textAlign: "center",
    color: "#666",
    fontSize: "0.92em",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
};

const copyrightRowStyle: React.CSSProperties = {
    display: "flex",
    gap: 18,
    justifyContent: "center",
    alignItems: "center"
};

const imgStyle: React.CSSProperties = {
    height: 36,
    objectFit: "contain"
};

export const Footer = () => (
    <footer style={outerBoxStyle}>
        <div style={containerStyle}>
            <img src={AQUAd} alt="AQUA-d" style={imgStyle} />
            <img src={phk} alt="PH Karlsruhe" style={imgStyle} />
            <img src={tue} alt="Universität Tübingen" style={imgStyle} />
            <img src={mwk} alt="MWK Baden-Württemberg" style={imgStyle} />
        </div>
        <section style={copyrightStyle}>
            <div style={copyrightRowStyle}>
                <small>© 2025 Julian Polly</small>
                <small>Stand: {new Date().toLocaleDateString("de-DE")}</small>
            </div>
        </section>
    </footer>
);